const downArrowheadIcon = (color = "currentColor") => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 8 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.7653 3.26463L4.2653 5.76464C4.23046 5.7996 4.18906 5.82733 4.14348 5.84626C4.0979 5.86519 4.04903 5.87493 3.99967 5.87493C3.95032 5.87493 3.90145 5.86519 3.85587 5.84626C3.81029 5.82733 3.76889 5.7996 3.73405 5.76464L1.23405 3.26463C1.1636 3.19419 1.12402 3.09864 1.12402 2.99901C1.12402 2.89938 1.1636 2.80383 1.23405 2.73338C1.3045 2.66294 1.40005 2.62336 1.49967 2.62336C1.5993 2.62336 1.69485 2.66294 1.7653 2.73338L3.99999 4.96807L6.23467 2.73307C6.30512 2.66262 6.40067 2.62305 6.5003 2.62305C6.59993 2.62305 6.69548 2.66262 6.76592 2.73307C6.83637 2.80352 6.87595 2.89907 6.87595 2.9987C6.87595 3.09833 6.83637 3.19387 6.76592 3.26432L6.7653 3.26463Z"
				fill={color}
			/>
		</svg>
	);
};

export default downArrowheadIcon;
